import React from 'react';

import { Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { kRDrawerSelector } from 'selectors/kRDrawer';
import { kRDrawerSecondaryPanelSelector } from 'selectors/krSecondaryPanel';

import { OKR_TYPES } from 'constants/ProjectConstants';
import { StringModifier, modifyString } from 'constants/copyHelpers';

import { Divider } from 'uiToolkitV1/Divider';

import { SecondaryPanelHeader as AddOKRPanelHeader } from '../../Components/SectionHeaders';
import { closeSecondaryPanel } from '../../krDrawerSecondaryPanelSlice';
import { CreateOKRPanelContent } from './CreateOKRPanelContent';
import CreateOKRPanelFooter from './CreateOKRPanelFooter';

export const CreateOKRPanel = ({ isOpenAsParent }) => {
  const { objectivesName, keyResultsName } = useOrganisationSettings();
  const dispatch = useDispatch();
  const history = useHistory();

  const onCollapse = () => {
    dispatch(closeSecondaryPanel());
  };

  const secondaryPanelDetailsObject = useSelector(kRDrawerSecondaryPanelSelector);
  const { uuid, type: parentType } = useSelector(kRDrawerSelector);

  const { details } = secondaryPanelDetailsObject;

  const isObjective = details?.okrDetails
    ? details?.okrDetails?.type === OKR_TYPES.OBJECTIVE
    : details?.type === OKR_TYPES.OBJECTIVE;

  const headerText = `Add ${
    isObjective
      ? modifyString(objectivesName, StringModifier.TITLE_CASE)
      : modifyString(keyResultsName, StringModifier.TITLE_CASE)
  }`;

  return (
    <Flex w="100%" backgroundColor="#FFFFFF" h="100%" flexDirection="column">
      {!isOpenAsParent && <AddOKRPanelHeader headerText={headerText} onCollapse={onCollapse} />}
      {!isOpenAsParent && <Divider sx={{ borderColor: '#CFD7DF' }} />}{' '}
      <CreateOKRPanelContent isOpenAsParent={isOpenAsParent} />
      <Divider sx={{ borderColor: '#CFD7DF' }} />
      <CreateOKRPanelFooter
        onKeyResultCreation={details?.onKeyResultCreation}
        onObjectiveCreation={details?.onObjectiveCreation}
      />
    </Flex>
  );
};
